import React from 'react';

import { AlertContainer } from './styles';
import { IAlert } from './types';

const Alert = ({ children, level = 'error', ...rest }: IAlert) => (
  <AlertContainer level={level} {...rest}>
    {children}
  </AlertContainer>
);

export default Alert;
